import { Badge } from "design-system/atoms/Badge"
import { Tooltip, TooltipContent, TooltipTrigger } from "design-system/atoms/Tooltip"
import { TagBadge } from "modules/customers/components/Tags/TagBadge"

const MAX_VISIBLE_TAGS = 2

type Props = {
  tags: { id: string; name: string }[]
}

export function CustomerTagsCell({ tags }: Props) {
  if (tags.length === 0) return "-"

  const visibleTags = tags.slice(0, MAX_VISIBLE_TAGS)
  const hiddenTags = tags.slice(MAX_VISIBLE_TAGS)

  return (
    <div className="flex max-w-64 items-center gap-1">
      {visibleTags.map((tag) => (
        <TagBadge key={tag.id} name={tag.name} className="h-6 min-w-0 px-2" />
      ))}
      {hiddenTags.length > 0 && (
        <Tooltip>
          <TooltipTrigger asChild>
            <span className="shrink-0">
              <Badge variant="outline" className="h-6 px-2 text-muted-foreground shadow-none">
                {`+${hiddenTags.length}`}
              </Badge>
            </span>
          </TooltipTrigger>
          <TooltipContent>{hiddenTags.map((tag) => tag.name).join(", ")}</TooltipContent>
        </Tooltip>
      )}
    </div>
  )
}
